import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BaseRestService } from './base-rest.service';
import { forkJoin, Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { UserService } from './user.service';
import { User } from '../models/user';
import { IUserSettingList, UserSetting } from '../models/user-setting';

@Injectable({ providedIn: 'root' })
export class UserSettingService extends BaseRestService<UserSetting, IUserSettingList>{

  constructor(http: HttpClient, private userService: UserService, protected router: Router) {
    super(UserSettingService, http, 'api/usersettings', 'user setting', router);

    // enable caching
    this.cacheEnabled = true;
  }

  save(entity: UserSetting, successMessage?: string) {
    if (entity && entity.userId) {
      entity.user = null;
    }
    super.save(entity, successMessage);
  }

  getSetting(name: string, defaultValue?: string) {
    const id = this.userService.getCurrentUserId();
    let item = this.getCache().find((i) => ((i.userId === id) && (i.name.toLowerCase() === name.toLowerCase())));
    if (!item) {
      item = new UserSetting();
      item.name = name;
      item.userId = id;
      if (defaultValue) {
        item.value = defaultValue;
      }
    }
    return item;
  }

  setSetting(name: string, value: string, userUid?: string) {
    const id = this.userService.getCurrentUserId();
    let item = this.getCache().find((i) => ((i.userId === id) && (i.name.toLowerCase() === name.toLowerCase())));
    let newItem:boolean=false;
    if (!item) {
      item = new UserSetting();
      item.name = name;
      item.userId = id;
      newItem=true;
    }    
    // Only save if value changed or newTtem cached
    if (item.value != value || newItem==true) {      
      item.value = value;
      this.save(item);
    }
  }

  hydrate(item: UserSetting): Observable<UserSetting> {
    const hydrate$ = [];

    // user
    if ((!item.user) || (item.user.id !== item.userId)) {
      hydrate$.push(this.userService.getById(item.userId).pipe(take(1), map((user) => {
        item.user = new User(user);
        return item;
      })));
    }

    if (hydrate$.length > 0) {
      return forkJoin(hydrate$).pipe(take(1), map((_) => {
        return item;
      }));
    }
    else {
      return of(item);
    }
  }
}
